import React, { Fragment } from 'react';
import AccountsHeading from 'Components/Blueprint/UI/Accounts/Heading';
import AccountsTable from 'Components/Blueprint/UI/Accounts/Table';
import AccountsTableInner from 'Components/Blueprint/UI/Accounts/TableInner';
import ShadowBox from 'Components/UI/ShadowBox';
import EditButton from 'Components/Blueprint/UI/EditButton';
import Currency from 'Components/Format/Currency';
import Content from 'Components/Blueprint/UI/Content';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';

const View = ({
  properties,
  personalAssets,
  vehicles,
  getEditLink,
  onClickEdit,
}) => {
  return (
    <div className="real-assets">
      {(properties && properties.length > 0)
      || (personalAssets && personalAssets.length > 0)
      || (vehicles && vehicles.length > 0) ? (
        <Fragment>
          <AccountsHeading
            title="Real Assets"
            editLink={getEditLink('realAssets', '')}
            editTooltip="Edit Real Assets"
          >
            <AccountsTable className="accounts-real-assets">
              <tr className="headings">
                <td className="type">Type</td>
                <td className="value">Value</td>
                <td className="purchase-price">Purchase Price</td>
                <td className="description">Description</td>
                <td className="owner">Owner/Title</td>
                <td className="notes">Notes</td>
              </tr>
            </AccountsTable>
          </AccountsHeading>
          <Fragment>
            <AccountsTableInner>
              <ShadowBox>
                <AccountsTable className="accounts-real-assets">
                  {/*
                  |--------------------------------------------------------------------------
                  | Properties
                  |--------------------------------------------------------------------------
                  */}
                  {properties && properties.length > 0
                  && properties.map(property => (
                    <tr key={`${property.id()}ra`} className="data">
                      <EditButton
                        title="Edit Property"
                        onClick={() => { onClickEdit(property); }}
                      />
                      <td className="type">Real Estate</td>
                      <td className="value">
                        {property.attr('value') !== null && (
                          <Currency amount={property.attr('value')} />
                        )}
                      </td>
                      <td className="purchase-price">
                        {property.attr('purchasePrice') !== null && (
                          <Currency amount={property.attr('purchasePrice')} />
                        )}
                      </td>
                      <td className="description">
                        {property.selectedOptions('subType', 'prompt')}
                      </td>
                      <td className="owner">{property.selectedOptions('ownerClientId', 'prompt')}</td>
                      <td className="notes">
                        {property.attr('notes')}
                      </td>
                    </tr>
                  ))}
                  {/*
                  |--------------------------------------------------------------------------
                  | Personal Assets
                  |--------------------------------------------------------------------------
                  */}
                  {personalAssets && personalAssets.length > 0
                  && personalAssets.map(personalAsset => (
                    <tr key={`${personalAsset.id()}pa`} className="data">
                      <EditButton
                        title="Edit Personal Asset"
                        onClick={() => { onClickEdit(personalAsset); }}
                      />
                      <td className="type">Personal Asset</td>
                      <td className="value">
                        {personalAsset.attr('value') !== null && (
                          <Currency amount={personalAsset.attr('value')} />
                        )}
                      </td>
                      <td className="purchase-price">&nbsp;</td>
                      <td className="description">
                        {personalAsset.selectedOptions('subType', 'prompt')}
                      </td>
                      <td className="owner">{personalAsset.selectedOptions('ownerClientId', 'prompt')}</td>
                      <td className="notes">
                        {personalAsset.attr('notes')}
                      </td>
                    </tr>
                  ))}
                  {/*
                  |--------------------------------------------------------------------------
                  | Vehicle
                  |--------------------------------------------------------------------------
                  */}
                  {vehicles && vehicles.length > 0
                  && vehicles.map(vehicle => (
                    <tr key={`${vehicle.id()}vi`} className="data">
                      <EditButton
                        title="Edit Vehicle"
                        onClick={() => { onClickEdit(vehicle); }}
                      />
                      <td className="type">Auto</td>
                      <td className="value">
                        {vehicle.attr('value') !== null && (
                          <Currency amount={vehicle.attr('value')} />
                        )}
                      </td>
                      <td className="purchase-price">&nbsp;</td>
                      <td className="description">
                        {vehicle.attr('vehicleYear') !== null
                        && `${vehicle.attr('vehicleYear')} `}
                        {vehicle.attr('vehicleMake') !== null
                        && `${vehicle.attr('vehicleMake')} `}
                        {vehicle.attr('vehicleModel') !== null
                        && `${vehicle.attr('vehicleModel')}`}
                      </td>
                      <td className="owner">{vehicle.selectedOptions('ownerClientId', 'prompt')}</td>
                      <td className="notes">{vehicle.attr('notes')}</td>
                    </tr>
                  ))}
                </AccountsTable>
              </ShadowBox>
            </AccountsTableInner>
          </Fragment>
        </Fragment>
        ) : (
          <Fragment>
            <AccountsHeading title="Real Assets" />
            <Content className="double-side-padding no-top-padding">
              <p>No real assets.</p>
            </Content>
          </Fragment>
        )}
    </div>
  );
};

View.propTypes = {
  properties: PropTypes.array,
  personalAssets: PropTypes.array,
  vehicles: PropTypes.array,
  getEditLink: PropTypes.func,
  onClickEdit: PropTypes.func.isRequired,
};
View.defaultProps = {
  getEditLink: noop,
  properties: [],
  personalAssets: [],
  vehicles: [],
};

export default View;
